import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	emptyTableMessage: {
		id: 'fastshift.table.empty-table-message',
		defaultMessage: 'We couldn’t find what you’re looking for.',
		description: 'Message for empty table',
	},
});
